export default "__VITE_ASSET__2ae70d12__"